import {
  fetchAllSuccessPlans,
  loadAllSuccessPlans,
} from '../routines/successPlanRoutines';

const initialState = {
  allSuccessPlansList: [],
  paginationData: {},
  allSuccessPlansLoading: false,
  allSuccessPlansSuccess: false,
  allSuccessPlanByEntity: [],
  allSuccessPlanByEntityLoading: false,
  allSuccessPlanByEntitySuccess: false,
  selectedAllSuccessPlan: {},
  selectedAllSuccessPlanLoading: {},
  selectedAllSuccessPlanSuccess: {},
  currentAllSuccessPlanPayload: null,
};

const allSuccessPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchAllSuccessPlans.TRIGGER:
      return {
        ...state,
        allSuccessPlansLoading: true,
      };
    case fetchAllSuccessPlans.SUCCESS: {
      const { response, currentPayload } = action.payload;
      const {
        allSuccessPlans,
        page,
        pageSize,
        total,
        organizationsCount,
        accountsCount,
      } = response;
      return {
        ...state,
        allSuccessPlansLoading: false,
        allSuccessPlansList: allSuccessPlans || [],
        allSuccessPlansPaginationData: {
          page,
          pageSize,
          totalItems: total,
          organizationsCount,
          accountsCount,
        },
        currentPayload,
      };
    }
    case fetchAllSuccessPlans.FAILURE:
      return {
        ...state,
        allSuccessPlansLoading: false,
      };
    case loadAllSuccessPlans.TRIGGER:
      return {
        ...state,
        allSuccessPlansLoading: true,
      };

    default:
      return state;
  }
};

export default allSuccessPlanReducer;
